import cnBind from "classnames/bind";
import card_1 from "@/shared/assests/миссия.webp";
import card_2 from "@/shared/assests/история.webp";
import card_3 from "@/shared/assests/team/общее_фото.webp";
import card_4 from "@/shared/assests/добрые_дела.webp";
import { Routes } from "@/shared/constants";
import { HistoryCard } from "@/view/Main/component/HistoryBlock/component/HistoryCard";
import styles from "./HistoryBlock.module.scss";

const cx = cnBind.bind(styles);

export const HistoryBlock = ({ className }: { className?: string }) => {
    return (
        <div className={cx("history-block", className)}>
            <div className={cx("wrapper", "container")}>
                <h2>О компании</h2>
                <div className={cx("cards")}>
                    <HistoryCard globalHref={`${Routes.HISTORY}#mission_and_values`} title="Миссия и ценности" image={card_1.src} />
                    <HistoryCard globalHref={`${Routes.HISTORY}#company`} title="История компании" image={card_2.src} />
                    <HistoryCard globalHref={`${Routes.HISTORY}#team`} title="Наша команда" image={card_3.src} />
                    <HistoryCard globalHref={`${Routes.HISTORY}#good_works`} title="Добрые дела" image={card_4.src} />
                </div>
            </div>
        </div>
    );
};
